import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export default function NotFoundPage() {
  return (
    <main className="min-h-screen bg-background px-4 py-16 text-foreground">
      <Card className="mx-auto max-w-lg">
        <CardHeader>
          <p className="font-mono text-sm text-muted-foreground">404</p>
          <CardTitle className="text-2xl">Page not found</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            This address does not match a page in GIFT. Check the URL or return
            to the dashboard.
          </p>
          <Button asChild>
            <Link to="/">Go to dashboard</Link>
          </Button>
        </CardContent>
      </Card>
    </main>
  );
}
